import { useState, useEffect, type ChangeEvent, type FormEvent } from "react";
import { useAppDispatch } from "../../redux";
import type { IModalProps } from "../../types";
import { resetCountAction } from "./DashboardSlice";
import { REGISTRATION_NUMBER_LENGTHS } from "../../constants";
import { Close } from "@mui/icons-material";
import { Box, Modal, Button, Toolbar, Tooltip, TextField, IconButton, Typography } from "@mui/material";

export default function ResetCountModal(props: IModalProps) {
  const { isOpen, success, styles, handleClose } = props;

  const dispatch = useAppDispatch();

  const [registrationNumber, setRegistrationNumber] = useState<number | null>(null);

  useEffect(() => {
    if (success) {
      setRegistrationNumber(null);
      handleClose();
    }
  }, [success, handleClose]);

  const handleRegistrationNumberChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;

    if (!value || isNaN(Number(value))) return setRegistrationNumber(null);

    setRegistrationNumber(Number(value));
  };

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();

    if (!registrationNumber) return;

    await dispatch(resetCountAction(registrationNumber));
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      closeAfterTransition
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Box sx={styles.modalRoot}>
        <Tooltip title="Close" sx={styles.close}>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Tooltip>

        <Toolbar>
          <Typography variant="h6" component="h2">
            Reset Claimant Attempt Count
          </Typography>
        </Toolbar>

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            margin="normal"
            required
            fullWidth
            label="Registration Number"
            inputProps={{ maxLength: 7 }}
            value={registrationNumber ? registrationNumber : ""}
            onChange={handleRegistrationNumberChange}
          />

          <Button
            type="submit"
            fullWidth
            color="primary"
            variant="contained"
            sx={{ mt: 1 }}
            disabled={!REGISTRATION_NUMBER_LENGTHS.includes(String(registrationNumber).length)}
          >
            Rest Count
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
